<!--
index_1 비히클 레벨 분석 시작
index_2 분석데이터 전처리
  - overall 또는 '전체' 제거 -> vehicle = "전체"
  - 임시키 생성 : 미디어명_채널명_비히클명
  - 미니테이블 테이블row html 코드 만들기
  - 임시키 명이 같을 경우 'eImp' 합산. Hash Map 이용
index_3
  - GRPS 계산 - eIMP / output target 모수
  - 계수 가지고 오기
-->
<template>
<div class="animated fadeIn">
  <b-card style="height:500px" class="bs-callout bs-callout-primary panelScrollBar">
    <resize-observer @notify="handleResize" />
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="12">
          <span class="card-title wise-card-title">Vehicle Level Result </span>
          <span class="small text-muted wise-card-subtitle"> Vehicle Level Result</span>
        </b-col>
        <b-col sm="6">
          <br/>
            <table  id="vehicleTable"
                    data-search="false"
                    data-show-columns="false"
                    data-pagination="false"
                    data-detail-view="true"
                    data-detail-formatter="detailFormatter"
                    >
                <thead>
                    <tr>
                        <th data-field="media">미디어</th>
                        <th data-field="channel">채널</th>
                        <th data-field="vehicle">비히클</th>
                        <th data-field="target">output 타겟</th>
                        <th data-field="budgetLabel">예산(만원)</th>
                        <th data-field="cpmLabel">CPM</th>
                        <!-- <th data-field="eImp">E.Imp</th> -->
                        <th data-field="grps">GRPs</th>
                        <th data-field="reach1" >Reach 1+</th>
                        <th data-field="af" >A.F</th>
                    </tr>
                </thead>
            </table>
        </b-col>
        <b-col sm="6">
          <div v-if="!noVehicle" id="vehicleLevelChartdiv" class="CSSAnimationChart"></div>
          <div v-if="noVehicle">
            <div style="padding-left:30px;font-size:20px;font-weight:600;color:#DADFE1">
              <br>선택된 비히클이 없습니다.
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-card>
</div>
</template>

<script>
import reachFormData from "../../../common/ReachFormData.js";
import amchart from "../../../../custom/amcharts/amcharts.js";
import serial from "../../../../custom/amcharts/serial.js";
import vehicleLevelChart from "./vehicleLevelChart.js";
import bootstrapTable from "bootstrap-table";

export default {
  props: {
    rootFormData:null,
  },
  data() {
    return {
      formData: this.$_.clone(this.$session.get('inputFormData')),
      chartData: [],
      tableData: null,
      graphIndex:0,
      noVehicle:false,
    }
  }
  ,
  created: function() {
  }
  ,
  updated: function() {
  }
  ,
  mounted: function() {

    for(var i=0; i<this.formData.mediaListResult.length; i++) {
      this.formData.mediaListResult[i].eImp = this.formData.mediaListResult[i].outputImpression;
      this.formData.mediaListResult[i].outputTargetCode = this.formData.targetCode;
    }
    // index_1 비히클 레벨 분석 시작
    this.vehicleLevelAnalysis(this.graphIndex);
  }
  ,
  methods: {
    handleResize() {
      $('#vehicleTable').bootstrapTable('resetView');
    },
    changeChart(graphIndex) {
      vehicleLevelChart.drawChart(this.chartData[graphIndex], graphIndex+1);
    }
    ,
    vehicleLevelAnalysis(graphIndex) {
      var mediaList_tmp = {};
      var mediaList_result = [];

      // index_2 분석데이터 전처리
      for(var i=0; i<this.formData.mediaListResult.length; i++){
        // overall 또는 '전체' 제거 -> vehicle = "전체"
        if(this.formData.mediaListResult[i].vehicle != "전체"){
          // 임시키 생성 : 미디어명_채널명_비히클명
          this.formData.mediaListResult[i].tmpKey = this.formData.mediaListResult[i].media + "_"
          + this.formData.mediaListResult[i].channel + "_" + this.formData.mediaListResult[i].vehicle

          var tmp = mediaList_tmp[this.formData.mediaListResult[i].tmpKey];

          if(tmp == null){
            this.formData.mediaListResult[i].target_cnt = this.formData.demographic_cnt;
            this.formData.mediaListResult[i].target = this.formData.targetCode;
            this.formData.mediaListResult[i].budgetLabel = this.formData.mediaListResult[i].budgetStr;
            this.formData.mediaListResult[i].cpmLabel = this.formData.mediaListResult[i].cpmStr;
            this.formData.mediaListResult[i].eImps = this.formData.mediaListResult[i].eImp;

            mediaList_tmp[this.formData.mediaListResult[i].tmpKey] = this.formData.mediaListResult[i];
            mediaList_result.push(mediaList_tmp[this.formData.mediaListResult[i].tmpKey]);
            // 미니테이블 테이블row html 코드 만들기
            this.formData.mediaListResult[i].tag = '<tr>'
                                                    +'<td>'+ this.formData.mediaListResult[i].targetCode +'</td>'
                                                    +'<td>'+ this.formData.mediaListResult[i].budgetStr +'</td>'
                                                    +'<td>'+ this.formData.mediaListResult[i].cpmStr +'</td>'
                                                    +'<td>'+ this.formData.mediaListResult[i].eImpStr +'</td>'
                                                  +'</tr>';
          }else{
            // 임시키 명이 같을 경우 'eImp' 합산. Hash Map 이용
            tmp.eImps = parseFloat(tmp.eImps) + parseFloat(this.formData.mediaListResult[i].eImp);
            tmp.budgetLabel = '(multiple)'
            tmp.cpmLabel = '(multiple)'
            // 미니테이블 테이블row html 코드 만들기
            tmp.tag = tmp.tag + '<tr>'
                                  +'<td>'+ this.formData.mediaListResult[i].targetCode +'</td>'
                                  +'<td>'+ this.formData.mediaListResult[i].budgetStr +'</td>'
                                  +'<td>'+ this.formData.mediaListResult[i].cpmStr +'</td>'
                                  +'<td>'+ this.formData.mediaListResult[i].eImpStr +'</td>'
                                +'</tr>';
          }
        }else{

        }
      }
      if(mediaList_result.length>=1){
        this.noVehicle = false;
      }else{
        this.noVehicle = true; // 선택된 비히클이 없는경우
      }
      this.formData.mediaListResult = mediaList_result;

      // index_3 비히클 레벨 분석
      // GRPS 계산 --> eIMP / output target 모수
      for(var i=0; i<this.formData.mediaListResult.length; i++){
        this.formData.mediaListResult[i].grps =
        ((this.formData.mediaListResult[i].eImps / this.formData.demographic_cnt) * 100).toFixed(2);
        this.formData.mediaListResult[i].target = this.formData.targetCode;
      }
      var token=sessionStorage.getItem("myToken");
      var param=encodeURI(JSON.stringify(this.formData.mediaListResult));

      var data = new FormData();
      data.append('objs', param);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      // 계수 가지고 오기
      this.$http.post('/api/select/cffcntData?access_token='+token, data, config)
              .then((result) => {
                // 각각의 grps reach1 계산
                for(var i=0; i <result.data.length; i++){
                  var resultList = this.makeResultList(result.data[i], (parseInt(result.data[i].grps) + 200));
                  this.chartData.push(resultList);
                }
                //this.formData.mediaListResult = result.data;
                // 뭐지?
                for(var i=0; i<this.formData.mediaListResult.length; i++){
                  this.formData.mediaListResult[i].graphId = (i+1);
                  for(var j=0; j<result.data.length; j++){
                    if(this.formData.mediaListResult[i].tmpKey === result.data[j].tmpKey){
                      this.formData.mediaListResult[i].reach1 = result.data[j].reach1;
                      this.formData.mediaListResult[i].af = (this.formData.mediaListResult[i].grps / this.formData.mediaListResult[i].reach1).toFixed(2);
                    }
                  }
                }
                // 여기서 쓰는거 같지는 않은데
                this.rootFormData.vehicleLevelResult = this.formData.mediaListResult;

                if(this.formData.mediaListResult.length > 0){
                  vehicleLevelChart.drawChart(this.chartData[graphIndex], graphIndex+1);
                }else{
                  // 노데이터 표시 로직추가
                }

                var self = this;
                // 테이블 생성
                $(function () {
                  $('#vehicleTable').bootstrapTable({
                      height : 400,
                      data: self.formData.mediaListResult,
                      onClickRow: function (row, $element) {
                        $($element).addClass('selectedActive').siblings().removeClass('selectedActive');
                        self.changeChart((row.graphId-1));
                      },
                      detailFormatter: function(index, row) {
                        var html = [];
                        html.push('<table>');
                        var str = '<tr><th>타겟</th><th>예산</th><th>CPM</th><th>E.Imp</th></tr>';
                        html.push(str);
                        $.each(row, function(key, value) {
                          if(key == 'tag'){
                            html.push(value);
                          }
                        });
                        html.push('</table>');
                        // join() 메서드는 배열의 모든 요소를 연결해 하나의 문자열로 만듦
                        return html.join('');
                      }
                  });
                  var first = $("#vehicleTable > tbody tr:first")
                  $(first).addClass('selectedActive').siblings().removeClass('selectedActive');
                });
            })
    }
    ,
    makeResultList(resultData, max){
      var resultList = [];
      for(var i=0 ;i<max; i++){
        var reach1Result = { reach1:0, grps:0, bulletSize:1, bullet:null};
        reach1Result.reach1 = this.inputLevelCalc(resultData, i);
        reach1Result.grps = i;

        if(i == parseInt(resultData.grps)){
          reach1Result.reach1 = this.inputLevelCalc(resultData, resultData.grps);
          resultData.reach1 = reach1Result.reach1.toFixed(2); // 2018-07-16 add
          reach1Result.bulletSize=10;
          reach1Result.bullet='square';
          resultList.push(reach1Result);
        }else{
          resultList.push(reach1Result);
        }
      }
      return resultList;
    }
    ,
    inputLevelCalc(cffcnt, grps) {
      var z = (
        cffcnt.a +
        cffcnt.b1 * Math.log(grps) +
        cffcnt.b2 * Math.pow(Math.log(grps),2) +
        cffcnt.b3 * Math.pow(Math.log(grps),3)
      );
      var z2 = 1 + Math.exp(-z);
      var result = (cffcnt.lmt/z2) * 100;
      if(isNaN(result)){ // 여기에 넣기에는 너무 부담스럽지 않을까?
        result = 0;
      }
      return result;
    }
  }
}
</script>
<style src="../../../../custom/amcharts/amchart_plugins.min.css"></style>
<style src="bootstrap-table/dist/bootstrap-table.min.css"></style>



// WEBPACK FOOTER //
// src/views/reach/da/result/VehicleLevelResult.vue